module.exports = __webpack_public_path__ + "img/e0299a7.svg";